var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 2.5H4.15299C3.23383 2.5 2.48633 3.2475 2.48633 4.16667V15.8467C2.48633 16.7658 3.23383 17.5133 4.15299 17.5133H15.833C16.7522 17.5133 17.4997 16.7658 17.4997 15.8467V4.16667C17.4997 3.2475 16.7522 2.5 15.833 2.5H12.4997ZM15.833 6.66667H13.333V4.16667H15.833V6.66667ZM4.15299 8.33333H6.65299V11.68H4.15299V8.33333ZM8.31966 8.33333H11.6663V11.68H8.31966V8.33333ZM13.333 8.33333H15.833V11.68H13.333V8.33333ZM11.6663 4.16667V6.66667H8.31966V4.16667H11.6663ZM6.65299 4.16667V6.66667H4.15299V4.16667H6.65299ZM4.15299 13.3467H6.65299V15.8467H4.15299V13.3467ZM8.31966 15.8467V13.3467H11.6663V15.8467H8.31966ZM13.333 15.8467V13.3467H15.8338V15.8467H13.333Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxGrid);
export default __webpack_public_path__ + "static/media/bx-grid.7cea25e4c6934218fcfb30c3dab7fe70.svg";
export { ForwardRef as ReactComponent };